$(document).ready(function(){
  $(".buy_together_slide").slick({
    autoplay: false, //自動再生
    infinite: true, //スライドのループ有効化
    dots: false, //ドットのナビゲーションを表示
    slidesToShow: 5, //表示するスライドの数
    slidesToScroll: 5, //スクロールで切り替わるスライドの数
    dots: false,
    arrows: true,
    autoplaySpeed: 6000,
    responsive: [{
      breakpoint: 991,
      settings: {
        slidesToShow: 3, //表示するスライドの数
        slidesToScroll: 3,
      }
    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false,
        //dots: true,
      }
    }]
  });
});
$('.btn-minus').on('click', function(e) {
    var input = $(e.target).closest('.form-type-number').find('input');
    input[0]['stepDown']();
});
$('.btn-plus').on('click', function(e) {
    var input = $(e.target).closest('.form-type-number').find('input');
    input[0]['stepUp']();
});

